import ShineBorder from "./ShineBorder";
import { MagicCard } from "./MagicCard";
import { IconArrowNarrowRight } from "@tabler/icons-react";

interface CardComponentProps {
  onBeamCardClick: () => void;
  onBentoCardClick: () => void;
}

export default function CardComponent({
  onBeamCardClick,
  onBentoCardClick,
}: CardComponentProps) {
  return (
    <div className="p-8 pb-16 flex flex-col items-center bg-[#16423C]">
      {/* Title Section */}
      <div className="text-4xl text-[#C4DAD2] md:text-5xl font-bold text-center lg:pt-8">
        Accelerated <span className="text-[#6A9C89]">packaging</span>{" "}
        development
      </div>
      <div className="text-lg md:text-xl text-[#C4DAD2] font-medium mt-4 flex pb-8 justify-center items-center max-w-5xl text-center">
        Dive into the future of packaging development—our sophisticated system
        minimizes trial-and-error efforts significantly, guiding you towards the
        most effective options for sustainable product solutions.
      </div>

      {/* Button Section */}
      <div className="mb-8 lg:mb-16 flex">
        <a
          href="https://quodata.de/form/contact-us?form="
          target="_blank"
          rel="noopener noreferrer"
          className="w-full sm:w-auto"
        >
          <button className="px-6 flex justify-center items-center gap-3 py-3 text-lg font-semibold text-[#16423C] bg-[#C4DAD2] rounded-lg shadow-md hover:bg-[#B0C6B3] focus:outline-none focus:ring-2 focus:ring-[#6A9C89] transition-colors duration-300">
            Get the Case Study <IconArrowNarrowRight />
          </button>
        </a>
      </div>

      {/* Cards Section */}
      <div className="flex flex-col gap-12 lg:h-[250px] pb-16 lg:flex-row px-10 lg:px-20">
        <div onClick={onBeamCardClick} className="flex-1">
          <ShineBorder
            className="relative flex h-[250px] w-full flex-col items-center justify-center overflow-hidden rounded-lg border shadow-xl"
            color={["#4CAF50", "#8BC34A", "#C5E1A5"]}
          >
            <span className="pointer-events-none whitespace-pre-wrap bg-gradient-to-b from-[#16423C] to-[#C4DAD2]/30 bg-clip-text text-center text-3xl md:text-4xl lg:text-4xl font-semibold leading-none text-transparent pb-4">
              Packaging <br /> optimization
            </span>
          </ShineBorder>
        </div>

        <div onClick={onBentoCardClick} className="flex-1">
          <ShineBorder
            className="relative flex h-[250px] w-full flex-col items-center justify-center overflow-hidden rounded-lg border shadow-xl"
            color={["#4CAF50", "#8BC34A", "#C5E1A5"]}
          >
            <span className="pointer-events-none whitespace-pre-wrap bg-gradient-to-b from-[#16423C] to-[#6A9C89]/30 bg-clip-text text-center text-3xl md:text-4xl lg:text-4xl font-semibold leading-none text-transparent pb-4">
              Production of recycled compounds
            </span>
          </ShineBorder>
        </div>
      </div>
    </div>
  );
}
